import { getCompanyDetail } from 'api/company/companyDetail'
import { companyDetailKey } from './keys'
import { useQuery } from '@tanstack/react-query'

export const useCompanyDetailsByIdQuery = (
  companyId?: number | null,
  staleTime?: number
) => {
  return useQuery({
    queryKey: companyDetailKey(companyId ?? 0),
    queryFn: () => getCompanyDetail(companyId ?? 0),
    refetchOnReconnect: false,
    enabled: !!companyId,
    staleTime: staleTime ?? 0,
  })
}
